import type { ThemeDefinition } from 'vuetify'

export const hausperfektTheme: ThemeDefinition = {
	colors: {
		background: '#f5f5f5',
		primary: '#00a4a5',
		secondary: '#03CED0',
		error: '#b71c1c',
		accent: '#B2B2B2',
		nav: '#424242',
		table: '#ffffff',
		text: '#121212',
	},
}

// Aaremo-Marke (AAR-2003): Logo-Blau statt HausPerfekt-Tuerkis. Gilt nur dort,
// wo der Mandant selbst keine Farbe gesetzt hat. Die Navigation ist hell, weil
// inaktive Eintraege in der Primaerfarbe gezeichnet werden: #0054d8 auf dem
// dunklen #424242 haette nur 1,56:1 Kontrast. Sekundaer ist die Farbe des
// aktiven Eintrags und der markierten Tabellenzeile, mit weisser Schrift.
//
// Die festen Themes hell/dunkel setzen Primaer und Sekundaer nicht selbst;
// Vuetify liefert dann sein Tuerkis (#48A9A6 / #54B6B2) als aktive Farbe. Auf
// Aaremo-Domains bekommen sie darum eigene Werte. Dunkel braucht aufgehellte
// Toene: #0054d8 auf #121212 waere zu dunkel zum Lesen.
export const aaremoVariantColors = {
	light: { primary: '#0054d8', secondary: '#00309c' },
	dark: { primary: '#6ea0ff', secondary: '#a8c4ff' },
}

export const aaremoTheme: ThemeDefinition = {
	colors: {
		...hausperfektTheme.colors,
		...aaremoVariantColors.light,
		nav: '#ffffff',
	},
}

// Dieselbe Regel wie beim Logo (useClientStore().isHpDomain): nur
// HausPerfekt-Domains sind HausPerfekt, alles andere (auch die Capacitor-App,
// die keine Domain kennt) ist Aaremo.
export const isHausperfektDomain = (domain?: string | null) =>
	!!domain?.includes('hausperfekt')

export const brandTheme = (isHausperfekt: boolean | undefined) =>
	isHausperfekt ? hausperfektTheme : aaremoTheme

// Markenfarben fuer die festen Themes hell/dunkel. HausPerfekt bleibt bei
// Vuetifys Standard (leer), nur Aaremo ueberschreibt.
export const brandVariantColors = (
	isHausperfekt: boolean | undefined,
	variant: 'light' | 'dark'
) => (isHausperfekt ? {} : aaremoVariantColors[variant])
